export class EdocumentType {
    docType: number;
    docTypeCd: string;
    docTypeDesc: string;
}
